import { initMobileMenu } from '@/Components/BurgerMenu/mobileMenu'
import HeroAnimation from './JavaScript/hero-animation.mjs'
import ReadingProgress from './JavaScript/reading-progress.mjs'
import HeroBackground from './JavaScript/hero-background.mjs'
import FormsMitgliedschaftsformular from './JavaScript/forms-mitgliedschaftsformular.mjs'

const initPage = async () => {
  await initMobileMenu()

  // Initialize hero animation
  const heroAnimation = new HeroAnimation()
  heroAnimation.init()

  // Initialize reading progress bar
  const readingProgress = new ReadingProgress()
  readingProgress.init()

  // Initialize hero background animation
  console.log('DOM ready, attempting to create HeroBackground instance from app.js')
  new HeroBackground()

  const formsMitgliedschaftsformularElement = document.querySelector('[data-handle="mitgliedschaftsformular"]') || false
  if (formsMitgliedschaftsformularElement) {
    new FormsMitgliedschaftsformular(formsMitgliedschaftsformularElement)
  }
}

// Fix the document ready check
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  console.log('Document already complete/interactive, calling initPage directly.')
  initPage()
}
else {
  console.log('Adding DOMContentLoaded listener for initPage.')
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded event fired, calling initPage.')
    initPage()
  })
}
